import { FaFileInvoiceDollar, FaWallet } from 'react-icons/fa';
import { debtDuesColumns, creditDuesColumns } from '../../utils';
import GeneratedDebtService from '../../services/generatedDebts.service';
import GeneratedCreditService from '../../services/generatedCredits.service';
import { MODULE_CLASSES } from '../Reports/reportsCatalogData';

export { MODULE_CLASSES };

/**
 * Two-entry catalog for the Previsiones type cards. `tone` drives every
 * label that flips between the two types — inverted from the design mock,
 * because Deudas is money the company collects and Créditos/Pasividades is
 * money it pays (see DynamicTable.js's existing "Total a Cobrar"/"Total a
 * Pagar" split for the same two dataNames).
 */
export const PREDICTION_TYPES = [
	{
		id: 'deudas',
		title: 'Previsión de deudas',
		subtitle: 'Ingresos proyectados: cuotas de deudas a cobrar',
		module: 'cat-1',
		Icon: FaFileInvoiceDollar,
		tone: 'up',
		dataName: 'debtsDues',
		service: GeneratedDebtService,
		allKey: 'allDebtsDues',
		columnInfo: debtDuesColumns,
		amountKey: 'debt',
		labels: {
			totalLabel: 'Total a cobrar proyectado',
			countUnit: 'cuotas',
			amountHeader: 'Monto a cobrar',
			panelTitle: 'deudas',
		},
	},
	{
		id: 'creditos',
		title: 'Previsión de créditos',
		subtitle: 'Egresos proyectados: cuotas de pasividades a pagar',
		module: 'cat-5',
		Icon: FaWallet,
		tone: 'down',
		dataName: 'creditDues',
		service: GeneratedCreditService,
		allKey: 'allCreditDues',
		columnInfo: creditDuesColumns,
		amountKey: 'credit',
		labels: {
			totalLabel: 'Total a pagar proyectado',
			countUnit: 'operaciones',
			amountHeader: 'Monto a pagar',
			panelTitle: 'créditos',
		},
	},
];

export function getPredictionType(id) {
	return PREDICTION_TYPES.find((t) => t.id === id);
}
